import { storage } from './firebase';

export const deleteRaport = (id) =>
    storage.ref(`pdf/${id}.pdf`).delete();

export const getRaport = (id) =>
    storage.ref(`pdf/${id}.pdf`).getDownloadURL();

